export class Random {
  getCrypto() {
    const crypto = window.crypto;
    return crypto;
  }

  getSafeRandom() {
    const arr = new Uint32Array(1);
    const crypto = this.getCrypto();
    crypto.getRandomValues(arr);
    const num = "0." + arr[0];
    // return num;
    return Number(num);
  }

  getRandom() {
    return Math.random();
  }
}
